module.exports = __webpack_public_path__ + "img/James Zaki.808b867b.jpg";